export default "__VITE_ASSET__DgJGAUyb__"